/* eslint-disable */
import {IProductMedia} from './IProductMedia';
import {BhImage} from './BhImage';
import {Price} from './Price';
import {RedReviewSummary} from './RedReviewSummary';
import {ReactComponent} from './ReactComponent';
import {Picture} from './Picture';
import {ProductMeta} from './ProductMeta';
export interface IWidget {
	id: string;
	type: WidgetType;
}
export enum WidgetType {
	Media = 0,
	Splash = 1,
	Brand = 2,
	TopTested = 3,
	NewProduct = 4,
	
}
export enum MediaSize {
	Large = 0,
	Medium = 1,
	Zoom = 2,
	
}
/**
* @description Interface for Avensia.Commerce.Web.Models.Products.MediaWidget
*/
export interface MediaWidget {
	id: string;
	type: WidgetType;
	media: IProductMedia[];
	size: MediaSize;
	isActive: boolean;
}
/**
* @description Interface for Avensia.Commerce.Web.Models.Products.SplashWidget
*/
export interface SplashWidget {
	id: string;
	type: WidgetType;
	splashTextTop: string;
	splashTextMiddle: string;
	splashTextBottom: string;
	splashTextEnd: string;
	isCampaign: boolean;
	isBundleSavings: boolean;
	isPartialCampaign: boolean;
	isLowPrice: boolean;
	isLoweredPrice: boolean;
}
/**
* @description Interface for Avensia.Commerce.Web.Models.Products.BrandWidget
*/
export interface BrandWidget {
	id: string;
	image: BhImage;
	type: WidgetType;
}
/**
* @description Interface for Avensia.Commerce.Web.Models.Products.TopTestedWidget
*/
export interface TopTestedWidget {
	id: string;
	type: WidgetType;
	image?: BhImage;
}
/**
* @description Interface for Avensia.Commerce.Web.Models.Products.IsNewProductWidget
*/
export interface IsNewProductWidget {
	id: string;
	type: WidgetType;
}
/**
* @description Interface for Avensia.Commerce.Web.Models.Products.ListViewProduct
*/
export interface ListViewProduct {
	productId: string;
	title: string;
	titleSplitPos: number;
	url: string;
	ticket: string;
	price: Price;
	isFamily: boolean;
	productImage: BhImage;
	brandLogo: BhImage;
	splashTextTop: string;
	splashTextMiddle: string;
	splashTextBottom?: string;
	splashTextEnd: string;
	articleGroup: string;
	isCampaign: boolean;
	isBundleSavings: boolean;
	isPartialCampaign: boolean;
	isLowPrice: boolean;
	isLoweredPrice: boolean;
	isNewProduct: boolean;
	reviewAvgScore: number;
	/**
    * @version - Property is marked as versioned and might not exist for usage
    **/
    reviewSummary?: RedReviewSummary;
	efficiencyArrow?: string;
	efficiencyDeclarationUrl?: string;
	efficiencyLabel?: ReactComponent[];
	efficiencyLabel2020?: Picture[];
	widgets?: IWidget[];
	meta?: ProductMeta;
	brandName: string;
	isPartPrice: boolean;
	partPriceUnit: string;
	thecaUrl?: string;
	tacticalFlagMarking?: string;
	tacticalFlagColor?: string;
	isTopTested?: boolean;
}
